var exports = {
  "mm": "editorButton__7hBGbJ",
  "p_": "list__OLMXcJ",
  "EX": "small__XAkqoa",
  "tm": "editorIcon__aYdB2E",
  "rv": "itemText__JUDFqY",
  "AS": "item__tOmmcZ",
  "AP": "itemTextAppendix__VLeSJ5",
  "HK": "itemSubtext__srBlf9",
};

module.exports = exports;
